import type { ByDate } from "../../model/types";

/**
 * Check if the availability for a restaurant has been fetched.
 *
 * Note:
 * - `null` availability means it has been fetched, but nothing was found.
 * - `undefined` availability means it hasn't been fetched yet.
 */
export default function hasFetchedAvailability<AvailabilitySlotType>(
  date: string,
  restaurantAvailability:
    ByDate<AvailabilitySlotType[] | null | undefined> | null | undefined,
) {
  if (restaurantAvailability === undefined) {
    return false;
  }

  if (restaurantAvailability === null) {
    return true;
  }

  // week
  if (date === "week") {
    const weekAvailability = Object.values(restaurantAvailability);
    return weekAvailability.some(
      (dayAvailability) => dayAvailability !== undefined,
    );
  }

  // day
  const dateAvailability = restaurantAvailability[date];
  return dateAvailability !== undefined;
}
